import React from 'react'

const GifIcon = () => {
  return (
    <svg width="21" height="21" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.16406 5.49805C6.16406 5.49805 4.16406 5.49805 3.66406 5.49805C3.16406 5.49805 2.66406 5.49805 2.66406 6.49805C2.66406 7.49805 2.66406 7.99805 2.66406 8.99805C2.66406 9.99805 2.66409 9.99805 3.66406 9.99805C4.66403 9.99805 5.66406 9.99805 5.66406 9.99805V7.87305H3.82034" stroke="#e53935"/>
      <path d="M6.91406 5.49805H8.05469M9.19531 5.49805H8.05469M8.05469 5.49805V9.99805M8.05469 9.99805H6.91406M8.05469 9.99805H9.19531" stroke="#e53935"/>
      <path d="M13.8984 5.49805H10.4922V7.74805M10.4922 10.502V7.74805M10.4922 7.74805H13.0859" stroke="#e53935"/>
      <path d="M0.5 0.5H15.5V15C15.5 15.2761 15.2761 15.5 15 15.5H1C0.723857 15.5 0.5 15.2761 0.5 15V0.5Z" stroke="#e53935"/>
    </svg>
  )
}

export default GifIcon
